import React from 'react';

import { Box } from '@mui/material';

import './Loading.scss';
import { LoadingImg } from 'assets/images';

const Loading = () => {
    return (
        <Box className="loadingWrapper">
            <Box className="logo">
                <img
                    src={
                        process.env.PUBLIC_URL +
                        process.env.REACT_APP_LOGO_VERTICAL_PATH
                    }
                    alt="logo"
                />
            </Box>
            <Box className="laoding">
                <img src={LoadingImg} alt="loading..." />
            </Box>
        </Box>
    );
};

export default Loading;
